import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

import type { PageSection } from '@sshop/domain';
import { useTranslation } from '@sshop/i18n';
import { cn } from '@sshop/ui';

import { isDarkBannerColor } from '@/shared/lib/bannerColor';

import { categoriesMenuStyles as s } from './CategoriesMenu.styles';

export function CategoriesMenuPromoCard({
  banner,
  compact = false,
  onNavigate,
}: {
  banner: PageSection;
  compact?: boolean;
  onNavigate: () => void;
}) {
  const { t } = useTranslation();
  const color = banner.bgColor ?? '#FFC107';
  const dark = isDarkBannerColor(color);

  return (
    <article
      className={cn(s.featured, compact ? s.mobileFeatured : s.desktopFeatured)}
      style={{ backgroundColor: color }}
    >
      {banner.tag ? (
        <span
          className={dark ? s.featuredEyebrowDark : s.featuredEyebrow}
          style={dark ? undefined : { color }}
        >
          {banner.tag}
        </span>
      ) : null}
      <h3 className={cn(dark ? s.featuredTitleDark : s.featuredTitle, s.featuredTitleClamp)}>
        {banner.title}
      </h3>
      {!compact && banner.text ? (
        <p className={cn(dark ? s.featuredTextDark : s.featuredText, s.featuredTextClamp)}>
          {banner.text}
        </p>
      ) : null}
      {banner.link ? (
        <Link
          to={banner.link}
          className={dark ? s.featuredCtaDark : s.featuredCta}
          onClick={onNavigate}
        >
          <span className="truncate">{banner.ctaLabel || t('home.learnMore')}</span>
          <ArrowRight className="h-3.5 w-3.5 shrink-0" aria-hidden />
        </Link>
      ) : null}
    </article>
  );
}
